module.exports = __webpack_public_path__ + "img/47_14.341c805f.png";